import {useNavigation, useRoute} from '@react-navigation/native';
import {Button} from '@ui-kitten/components';
import React, {useEffect, useMemo, useState} from 'react';
import {StyleSheet, Platform} from 'react-native';
import {useSelector} from 'react-redux';
import {getSubjects} from '../../apis';
import {AUTHENTICATED_ROUTES} from '../../navigation/constants';
import {getSubjectName, px, useAsync, useIsLandscape} from '../../utils';
import {renderIf} from '../../utils/Utils';
import {
  AppLoadingIndicator,
  CheckboxList,
  Page,
  PriceInfo,
} from '../components';
import {PaymentErrorModal} from './../Payment/PaymentErrorModal';

const packageTypes = {
  individual: 'Individual',
  package: 'Package',
  proPackage: 'Pro',
};

const ConfigurePackage = ({
  handleCloseModal,
  landscapeParams,
  setLandscapeRouteAndParams,
}) => {
  const navigation = useNavigation();
  const {params} = useRoute();
  const isLandscape = useIsLandscape();
  const {packageType, selectedStudent, monthNumber, title: packageTitle} =
    landscapeParams?.data || params?.data;
  const [totalPrice, setTotalPrice] = useState(0);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const packages = useSelector((state) => state.general.packages);

  var isPaymentError = false;
  if (selectedStudent && selectedStudent.gradeId) {
    //console.log('Process');
  } else {
    isPaymentError = true;
  }

  const currentPackage = packages.find(
    (item) =>
      item.gradeId === selectedStudent?.gradeId && item.type === packageType,
  );

  var unitPrice = Number(currentPackage?.price || 0);
  if (Platform.OS === 'ios') {
    unitPrice = Number(currentPackage?.ios_package_price || 0);
  }

  if (monthNumber === '02-2023' && Platform.OS !== 'ios') {
    unitPrice = 0;
  }

  useEffect(() => {
    if (
      packageType === packageTypes.package ||
      packageType === packageTypes.proPackage
    ) {
      setTotalPrice(unitPrice);
    }
  }, [packageType, unitPrice]);

  useEffect(() => {
    if (packageType === packageTypes.individual) {
      setTotalPrice(unitPrice * selectedSubjects.length);
    }
  }, [packageType, selectedSubjects, unitPrice]);

  const {loading: subjectsLoading, value: subjects} = useAsync(
    () => getSubjects(selectedStudent ? [selectedStudent.gradeId] : undefined),
    [selectedStudent],
  );

  const subjectsList = useMemo(
    () =>
      subjects
        ?.filter((subject) => {
          if (packageType === packageTypes.package) {
            return subject.subjectType === 'tutorial';
          }
          return true;
        })
        ?.map(({id, name, languageCode, subjectType}) => ({
          id,
          text: getSubjectName(name, languageCode, subjectType),
          value: id,
          name,
          languageCode,
          subjectType,
        }))
        .sort((a, b) => {
          if (a.name === b.name) {
            if (a.languageCode === b.languageCode) {
              if (
                a.subjectType === 'intensive' ||
                a.subjectType === 'tutorial'
              ) {
                return a.subjectType > b.subjectType ? -1 : 1;
              } else {
                return a.subjectType < b.subjectType ? -1 : 1;
              }
            }
            return a.languageCode > b.languageCode ? 1 : -1;
          }
          return a.name > b.name ? 1 : -1;
        }),
    [packageType, subjects],
  );

  return (
    <Page
      header={{
        title: 'Subjects',
        showBackAction: true,
        onModalBackPressed() {
          handleCloseModal();
        },
      }}
      useModalView={isLandscape}>
      {renderIf(isPaymentError, <PaymentErrorModal />)}

      {subjectsLoading ? (
        <AppLoadingIndicator />
      ) : (
        <CheckboxList
          title="Please select the subjects"
          // todo: passing an array with length of 0 will cause crash.
          list={subjectsList?.length === 0 ? undefined : subjectsList}
          selectedItems={selectedSubjects}
          setSelectedItems={setSelectedSubjects}
        />
      )}

      <PriceInfo
        totalPrice={totalPrice}
        type={packageType}
        title={packageTitle}
        unitPrice={unitPrice}
      />
      <Button
        disabled={!selectedSubjects.length}
        style={styles.submitButton}
        onPress={() => {
          const paramsToSet = {
            packageId: currentPackage?.id,
            gradeId: currentPackage?.gradeId,
            packageType: currentPackage?.type,
            iosProductId: currentPackage?.ios_product_id,
            packageTitle: packageTitle,
            totalPrice,
            unitPrice,
            studentGradeId: selectedStudent?.gradeId,
            selectedSubjects,
            selectedStudent,
            monthNumber,
          };
          const routeToSet = AUTHENTICATED_ROUTES.selectTimeTable.path;

          if (isLandscape) {
            setLandscapeRouteAndParams(routeToSet, paramsToSet);
          } else {
            navigation.navigate(routeToSet, paramsToSet);
          }
        }}>
        {'Select Timetable'}
      </Button>
    </Page>
  );
};

const styles = StyleSheet.create({
  submitButton: {
    margin: px(17),
    marginTop: px(10),
    marginBottom: px(15),
  },
});

export default ConfigurePackage;
